import { FC } from "react"
import { Box, Link } from "@mui/material"
import OpenInNewIcon from "@mui/icons-material/OpenInNew"

interface IProps {
  url: string | null
}

export const ReportLinkCell: FC<IProps> = ({ url }) => {
  if (!url) return <Box sx={{ color: "text.disabled" }}>—</Box>
  return (
    <Link
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}
    >
      Открыть&nbsp;
      <OpenInNewIcon fontSize="small" />
    </Link>
  )
}
